import React, { Component } from "react";
import PropTypes from "prop-types";
import { StorageHandler } from "C4";
import { storageKeys, baseAppId } from "settings";

export default class BackImage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      image: null,
      size: null,
    };
  }

  componentDidMount() {
    this.loadBgImage();
  }

  async loadBgImage() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      this.setState({
        image: appInfo.backgroundImage,
        size: {
          width: document.body.clientWidth,
          height: document.body.clientHeight,
        },
      });
    }
  }

  render() {
    const { image, size } = this.state;
    const { blur, darken } = this.props;

    let imgixUrl = `https://front.travpromobile.com/${baseAppId}/bg@2x.jpg`;
    if (image) {
      imgixUrl = `${imgixUrl.replace(
        "front.travpromobile.com",
        "travprocdn.imgix.net"
      )}?width=${size.width}`;
    }

    return (
      <div className="bgImage">
        {image && (
          <div
            style={{ backgroundImage: `url("${imgixUrl}")` }}
            className={`backgroundImage ${blur && "blur"} ${
              darken && "darken"
            }`}
          />
        )}
      </div>
    );
  }
}

BackImage.propTypes = {
  blur: PropTypes.bool,
  darken: PropTypes.bool,
};

BackImage.defaultProps = {
  blur: false,
  darken: false,
};
